import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginRequest } from 'src/app/models/login.model';
import { Global } from '../../global/global';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private httpClient: HttpClient,
    private userService: UserService
  ) { }

  authenticate(loginRequest: LoginRequest) {
    return this.httpClient.post(Global.BASE_API_URL + '/api/auth/login', loginRequest, { observe: 'response', responseType: 'text' })
  }

  public isUserLoggedIn(): boolean {
    let user = localStorage.getItem('token')
    return !(user === null)
  }

  public logOut() {
    localStorage.removeItem('token')
    this.userService.deleteUserStorage();
  }
}
